import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaPaintBrush,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CreativeVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Creative Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unleash Your Vision</Subheading>}
        heading={
          <Heading>
            Creative <span tw="text-primary-500">Video Production</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in creative video production in **Bur
            Dubai**, delivering innovative, visually stunning videos that tell
            unique stories for brands, campaigns, and artistic projects.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1601506521937-0b4218f2e801?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Film production setup
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Creative lighting effects
          "https://images.unsplash.com/photo-1580983218765-f663bec07b37?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Creative Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Innovative Video Production in Bur Dubai"
        description="We bring artistry and imagination to every video project."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Artistic Storytelling",
            description: "Unique narratives that captivate and inspire.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Stunning Visuals",
            description: "High-quality, cinematic production techniques.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Swift Turnaround",
            description: "Fast delivery without sacrificing creativity.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Videos optimized for web, social, and presentations.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Creators",
            description: "Bur Dubai’s choice for creative videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Tailored Concepts",
            description: "Customized for brands, campaigns, or art.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Creative Video Process"
        description={
          <Description>
            We craft imaginative videos with a refined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Explore your creative vision and goals.</li>
              <li>Concepting: Develop bold, original storyboards.</li>
              <li>Filming: Capture visuals with innovative techniques.</li>
              <li>Editing: Enhance with effects, color grading, and sound.</li>
              <li>Delivery: Provide polished videos that stand out.</li>
              <li>Support: Offer revisions to perfect your vision.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Studio production setup
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Artistic video composition
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Creative Video Wins in Bur Dubai"
        description="Our creative videos have inspired and engaged audiences."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Brand Impact",
            description: "Transformed campaigns with bold visuals.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Acclaim",
            description: "93% satisfaction from Bur Dubai creators.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Viral Reach",
            description: "Videos shared widely across platforms.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready to Create Something Extraordinary?</Subheading>
        }
        heading="Creative Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert creative video production in
            Bur Dubai. Get innovative, standout videos to elevate your
            vision—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1546412414-e1885259563a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
